/*
 * @Author: edvardchen
 * @Date:   2016-12-19 15:21:42
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2020-02-14 18:11:06
 */
// @flow
import { parse, stringify } from 'query-string';
const url = require('url');

const parseUrl = (url = '') => {
  const elm = document.createElement('a');
  elm.href = url;
  const { origin, protocol, pathname, search, hash, host } = elm;
  return {
    host,
    origin,
    protocol,
    pathname,
    query: parse(search),
    hash,
  };
};

const format = ({ host, protocol, pathname, query, hash = '' }) => `${protocol}//${host}${pathname}?${stringify(query)}${hash}`;

export {
  parseUrl,
  format,
  url
}
